import {createSvgIcon} from '../create-svg-icon';

export const SwitchLeftIcon = createSvgIcon(
  <path d="M8.5 8.62v6.76L5.12 12 8.5 8.62M10 5l-7 7 7 7V5zm4 0v14l7-7-7-7z" />
, 'SwitchLeftOutlined');
